import React from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return <div class="privacy-policy">
    <h2>Privacy Policy</h2>

    <p><strong>HalalCred LLC</strong> (“HalalCred,” “we,” “our,” or “us”) respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website, engage with our services, or participate in HalalCred’s riba-free financing and investment opportunities. Please read this policy carefully to understand our practices regarding your information.</p>

    <h3>1. Information We Collect</h3>
    <p>We may collect the following types of information:</p>

    <p><strong>Personal Information:</strong> When you register for our services, join the waitlist, apply for financing, or express interest in our offerings, we may collect personal details such as your name, email address, phone number, and other contact information.</p>

    <p><strong>Financial Information:</strong> If you are interested in financing or investment opportunities, we may collect details related to your financial qualifications, preferences, and other relevant financial data.</p>

    <p><strong>Property Information:</strong> If you apply for financing, we may collect information about the property you are seeking financing for, including location and ownership details.</p>

    <p><strong>Usage Data:</strong> We collect data on how you use our website, including IP address, browser type, pages viewed, and visit timestamps. This helps us enhance our website’s functionality and tailor our services to users’ needs.</p>

    <h3>2. How We Use Your Information</h3>
    <p>We use the information we collect for the following purposes:</p>

    <p><strong>Providing Services:</strong> To process your financing application, manage your participation in our offerings, and respond to inquiries.</p>

    <p><strong>Improving User Experience:</strong> To analyze website usage patterns and improve our website’s functionality and content.</p>

    <p><strong>Communications:</strong> To send you updates, promotional materials, and relevant information related to HalalCred, such as new financing options, investor updates, or changes to our policies.</p>

    <p><strong>Compliance:</strong> To comply with applicable laws, regulations, and legal obligations, including responding to regulatory inquiries and enforcing our terms of service.</p>

    <h3>3. How We Share Your Information</h3>
    <p>We may share your information with third parties under the following circumstances:</p>

    <p><strong>Service Providers:</strong> We may share your information with trusted service providers that assist us in operating our business, such as hosting providers, payment processors, or customer service platforms. These third parties are obligated to protect your information and use it only as directed by us.</p>

    <p><strong>Legal Requirements:</strong> We may disclose your information to comply with legal obligations, respond to legal processes, or protect our rights, property, and safety, or that of others.</p>

    <p><strong>Business Transfers:</strong> In the event of a merger, acquisition, or other business transaction, your information may be transferred to the new entity as part of the deal.</p>

    <h3>4. Your Data Protection Rights</h3>
    <p>You have the following rights regarding your personal information:</p>

    <p><strong>Access:</strong> You can request a copy of the personal information we hold about you.</p>

    <p><strong>Correction:</strong> You can request that we update or correct inaccurate information.</p>

    <p><strong>Deletion:</strong> You can request that we delete your personal information, subject to legal exceptions.</p>

    <p><strong>Objection or Restriction:</strong> You can object to or request restrictions on processing your personal information in certain cases.</p>

    <p><strong>Withdraw Consent:</strong> If we rely on your consent to process your information, you can withdraw that consent at any time.</p>

    <p>To exercise these rights, please contact us at <strong>salaam@halalcred.com</strong>.</p>

    <h3>5. Security of Your Information</h3>
    <p>We implement industry-standard security measures to protect your personal information from unauthorized access, use, or disclosure. However, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security.</p>

    <h3>6. Cookies and Tracking Technologies</h3>
    <p>We use cookies and similar tracking technologies to enhance your experience on our website. These help us understand how you interact with our site. You can manage cookie preferences through your browser settings. Disabling cookies may impact site functionality.</p>

    <h3>7. Third-Party Links</h3>
    <p>Our website may contain links to third-party websites. This Privacy Policy applies only to information collected by HalalCred. We are not responsible for the privacy practices of other websites and encourage you to read their privacy policies before providing any personal information.</p>

    <h3>8. Changes to This Privacy Policy</h3>
    <p>We may update this Privacy Policy from time to time to reflect changes in our practices, legal requirements, or operational needs. When we make changes, we will post the updated policy on this page and update the “Last Updated” date. We encourage you to review this policy periodically to stay informed about how we protect your information.</p>

    <h3>9. Contact Us</h3>
    <p>If you have any questions or concerns about this Privacy Policy or how we handle your information, please contact us at:</p>

    <p><strong>HalalCred LLC</strong></p>
    <p>📩 <strong>Email:</strong> <a href="mailto:salaam@halalcred.com">salaam@halalcred.com</a></p>
  </div>;
}

export default PrivacyPolicy;
